import request from '@/router/axios'

export const getCourseList = (current, size, params) => request({
  url: '/api/mcc-worker/workerprocesscourse/page1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const updateCourseInfo = params => request({
  url: '/api/mcc-worker/workerprocesscourse/updateCourse',
  method: 'post',
  data: params,
})

export const updateCourse = params => request({
  url: '/api/mcc-worker/workerprocesscourse/update',
  method: 'post',
  data: params,
})

export const downLoadAllCourseProcess = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCourse',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '27',
    ...params,
  },
})

export const courseDetail = params => request({
  url: '/api/mcc-worker/workerprocesscourse/detail1',
  method: 'get',
  params: {
    ...params,
  },
})

// 个人课程导出
export const downLoadCourseProcess = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCoursePerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '27',
    ...params,
  },
})

// 课程管理信息导出
export const downLoadCourseList = params => request({
  url: '/api/mcc-worker/workerprocesscourse/DaoChuCourseManage',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '27',
  },
})

export default {
  getCourseList,
}
